import { createStyles, css } from 'antd-style';

export default createStyles(({ token }) => {
  return {
    loginContainer: css`
      display: flex;
      flex-direction: column;
      height: 100vh;
      overflow: auto;
      background-image: url(../../../images/bg_VIA_collateral.svg);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #0f264c;
      justify-content: center;
      align-items: center;
    `,
    formContainer: css`
      max-width: 440px;
      background: #fff;
      max-height: 440px;
      height: 440px;
      border-radius: 50%;
      width: 440px;
      box-shadow: 15px 15px 25px rgba(0, 0, 0, .45);
      border: 15px solid #0f264c;
      padding: 30px 70px;
    `,
    pageTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
});